export enum DeepLinkTriggerActionsEnum {
  action = 'action',
  canvas = 'canvas',
  error = 'error',
  external_uri = 'external_uri', // web specific; handles http/https uri's
  home = 'home',
  navigate = 'navigate',
  no_action = 'no_action', // TODO: properly handle a `no action` (just act if as nothing happened)
  paywall = 'paywall',
  purchase = 'purchase',
  opt_out_trial = 'opt_out_trial',
}

export enum DeepLinkTriggerActionPathsEnum {
  error = 'error',
  refresh_settings = 'refresh_settings',
}

export enum DeepLinkTypeEnum {
  internal = 'internal',
  external = 'external',
}
